import React, { useEffect, useState } from "react";
import { DataGrid } from "@mui/x-data-grid";
import { Button, CircularProgress, IconButton } from "@mui/material";
import { FaPlay, FaRocket } from "react-icons/fa";
import { FaStop } from "react-icons/fa";
import { GoRocket } from "react-icons/go";

const DataTable = ({
  rows,
  columns,
  onDeleteSelected,
  onAssignToProxy,
  showAssignToCategory,
  showCategoryStart,
  showStartAndEndProcess,
  onBulkStart,
  onBulkStop,
  onCategoryStart,
  totalPages,
  currentPage,
  handlePageChange,
  totalItems,
  selectedCategoryId,
  columnVisibilityModel,
  saveColumnVisibility,
  onAttachAllGMBLink,
  attachAllGMBLink,
  onMultiLoginXStart,
  onMultiLoginXStop,
  showAllMultiLoginX,
  onMoveToAnotherCategory,
}) => {
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const handleDelayedAction = async (actionFn) => {
    setIsLoading(true);
    const startTime = Date.now();

    // Trigger the actual API call
    actionFn();

    // Ensure loader runs for at least 5 seconds
    const elapsed = Date.now() - startTime;
    const remainingTime = Math.max(0, 5000 - elapsed);

    setTimeout(() => {
      setIsLoading(false);
    }, remainingTime);
  };
  return (
    <div style={{ width: "100%", height: "70vh" }}>
      <DataGrid
        key={selectedCategoryId || 0}
        rows={rows}
        columns={columns}
        pageSize={100}
        checkboxSelection
        onRowSelectionModelChange={(newRowSelectionModel) => {
          setRowSelectionModel(newRowSelectionModel);
        }}
        rowSelectionModel={rowSelectionModel}
        paginationMode="server"
        rowCount={totalItems}
        page={currentPage - 1}
        onPaginationModelChange={(newPage) => {
          handlePageChange(newPage.page + 1);
        }}
        columnVisibilityModel={columnVisibilityModel}
        onColumnVisibilityModelChange={(newModel) =>
          saveColumnVisibility(newModel)
        }
        // disableColumnResize={false}
        pagination
        sx={{
          fontFamily: "Poppins, sans-serif",
          "& .MuiDataGrid-columnHeaders": {
            color: "white",
            fontSize: "1.25rem",
            alignSelf: "flex-end",
          },
          "& .MuiButtonBase-root": {
            color: "white",
          },
          "& .MuiDataGrid-row": {
            backgroundColor:
              "linear-gradient(to right, #000000, #06041f, #0d0d55, #15178e)",
            color: "white",
            "&:hover": {
              backgroundColor: "#2D3748",
            },
          },
          "& .MuiDataGrid-footerContainer": {
            backgroundColor:
              "linear-gradient(to right, #000000, #06041f, #0d0d55, #15178e)",
            color: "white",
          },
          "& .MuiTablePagination-selectLabel, & .MuiTablePagination-select, & .MuiTablePagination-displayedRows":
            {
              color: "white",
            },
          "& .MuiDataGrid-cell": {
            justifyContent: "center",
            display: "flex",
            alignItems: "center",
          },
          "& .super-app-theme--header": {
            ".MuiDataGrid-columnHeaderTitle": {
              fontWeight: "bold",
              textAlign: "center",
              flex: 1,
              justifyContent: "center",
            },
          },
          "& .MuiCheckbox-root svg": {
            color: "#2b9fdb",
          },
        }}
      />

      {showCategoryStart && (
        <Button
          variant="contained"
          color="info"
          disabled={isLoading}
          onClick={() => handleDelayedAction(onCategoryStart)}
          sx={{ mt: 2 }}
          endIcon={isLoading ? <CircularProgress size={20} /> : <FaRocket />}
        >
          {isLoading ? "Starting..." : "Start Category Accounts"}
        </Button>
      )}

      {showAllMultiLoginX && (
        <Button
          variant="contained"
          color="info"
          onClick={() => onMultiLoginXStart()}
          sx={{ mt: 2, ml: 2 }}
          endIcon={<FaRocket />}
        >
          Start Multi-Login X
        </Button>
      )}

      {showAllMultiLoginX && (
        <Button
          variant="contained"
          color="error"
          disabled={isLoading}
          onClick={() => handleDelayedAction(onMultiLoginXStop)}
          sx={{ mt: 2, ml: 2 }}
          endIcon={isLoading ? <CircularProgress size={20} /> : <FaStop />}
        >
          {isLoading ? "Stopping..." : "Stop Multi-Login X"}
        </Button>
      )}

      <Button
        variant="contained"
        color="error"
        onClick={() => onDeleteSelected(rowSelectionModel)}
        disabled={rowSelectionModel.length === 0}
        sx={{ mt: 2, ml: 2 }}
      >
        Delete Selected
      </Button>

      {showAssignToCategory && (
        <Button
          variant="contained"
          color="info"
          onClick={() => onAssignToProxy(rowSelectionModel)}
          disabled={rowSelectionModel.length === 0}
          sx={{ mt: 2, ml: 2 }}
        >
          Assign to Category
        </Button>
      )}

      {showStartAndEndProcess && (
        <Button
          variant="contained"
          color="success"
          onClick={() => onBulkStart(rowSelectionModel)}
          disabled={rowSelectionModel.length === 0}
          sx={{ mt: 2, ml: 2 }}
          endIcon={<FaPlay />}
        >
          Start Selected
        </Button>
      )}

      {showStartAndEndProcess && (
        <Button
          variant="contained"
          color="error"
          onClick={() => onBulkStop(rowSelectionModel)}
          disabled={rowSelectionModel.length === 0}
          sx={{ mt: 2, ml: 2 }}
          endIcon={<FaStop />}
        >
          Stop Selected
        </Button>
      )}

      {attachAllGMBLink && (
        <Button
          variant="contained"
          color="info"
          onClick={() => onAttachAllGMBLink(rowSelectionModel)}
          sx={{ mt: 2, ml: 2 }}
          disabled={rowSelectionModel.length === 0}
          endIcon={<GoRocket />}
        >
          Attach All GMB Link
        </Button>
      )}
      {selectedCategoryId !== "all" && rowSelectionModel.length > 0 && (
        <Button
          variant="contained"
          color="warning"
          sx={{ mt: 2, ml: 2 }}
          onClick={() => onMoveToAnotherCategory(rowSelectionModel)}
        >
          Move to another category
        </Button>
      )}
    </div>
  );
};

export default DataTable;
